import { AccountListPage } from './account.list.page';

export default AccountListPage;
